const doc = [({"en":({"js":({"admin":({"survey_judges":({"row":({"select_contact":"Select contact"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;